<template>
  <el-dialog
    title="修改状态"
    :visible.sync="examineDialog"
    :width="getIsMobile?'100%':'60%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" label-position="right" class="custom-form">
      <el-form-item label="合同状态" prop="zt" v-if="examineContract === '1'">
        <el-radio-group v-model="form.zt">
          <el-radio :label="0">未审</el-radio>
          <el-radio :label="1">已审</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开票状态" prop="kpzt" v-if="data.kpzt !== '未'">
        <el-radio-group v-model="form.kpzt">
          <el-radio :label="0">未开票</el-radio>
          <el-radio :label="1">已开票</el-radio>
        </el-radio-group>
      </el-form-item>
<!--      <el-form-item label="开票发票号" prop="kpfph">-->
<!--        <el-input v-model="form.kpfph" placeholder="请输入开票发票号"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="付款金额" prop="fukuan">
        <el-input v-model="form.fukuan" placeholder="请输入付款金额"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  components: {},
  props: {
    examineDialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    examineContract: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const formRef = ref(null)
    const form = reactive({
      zt: '',
      kpzt: '',
      // kpfph: '',
      fukuan: '',
    })

    watch(()=> props.formData, (val)=> {
      if (!val || typeof val !== 'object') return;
      Object.keys(val).forEach((key) => {
        if (key in form) {
          const value = val[key];

          // 判断 value 是否为字符串形式的纯数字
          form[key] = typeof value === 'string' && !isNaN(value)
            ? Number(value)
            : value;
        }
      });
    },{deep:true})

    const handleReset = () => formRef.value.resetFields()
    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }
    const handleClose = () => emit('close')

    watch(()=>props.examineDialog,(val)=>{
      if(val) {
        form.zt = Number(props.data.zt  === '已审'? '1' : '0')
        form.kpzt = Number(props.data.kpzt === '已开'? '1' : '0')
        form.fukuan = props.data.fukuan
      }
    },{deep:true,immediate:true})

    return {
      getIsMobile,
      formRef,
      form,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>

